<template>
  <div class="container">
    <div class="row align-self-center justify-content-center">
      <div class="col-5" id="initial-img-left"></div>
      <div class="col-7" id="initial-div-right">
        <div id="initial-sub-div-right">
          <div id="logo">
            <img src="@/assets/optum-logo.svg" />
          </div>

          <div v-if="isInSecondStep">
            <FormLoginSecondStep class="animate__fadeInUp"/>
          </div>
          <div class="input-login" v-else>
            <div id="indicators-initial" :class="{'reduce-bottom': this.selected === 1}">
              <img class="icon" src="@/assets/Icon.svg"/>
              <a href="#" :class="{ 'active-indicator': this.selected === 0 }" @click="changePage(0)">Login</a>
              <!-- <a href="#" :class="`ml-3 ${this.selected === 1 ? 'active-indicator' : ''}`" @click="changePage(1)">CADASTRE-SE</a> -->
            </div>
            <FormLogin v-if="this.selected === 0" class="animate__fadeInUp" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormLogin from "./components/FormLogin"
import FormLoginSecondStep from "./components/FormLoginSecondStep"
import {mapGetters} from "vuex"

export default {
  name: "Login",
  components: {
    FormLogin,
    FormLoginSecondStep
  },
  data() {
    return {
      selected: 0,
    };
  },
  computed: {
    ...mapGetters("user", ["jwt"]),
    isInSecondStep() {
        if (!this.jwt || !this.jwt.authorities) {
            return false
        }

        return this.jwt.authorities.includes("ROLE_SECOND_STEP_OAUTH")
    }
  },
  methods: {
    changePage( id ) {
      this.selected = id;
    }
  }
};
</script>

<style scoped>
div.container {
  margin: 0px;
  max-width: 100vw;
  background: #fbf9f4;
}

#indicators-initial a {
  margin-right: 30px;
  transition: 0.2s;
  font-weight: 600;
  text-decoration: none;
  color: inherit;
}

#indicators-initial a:hover {
  color: #FF612B !important;
  border-bottom: #FF612B solid 3px;
}

.active-indicator {
  border-bottom: #002677 solid 3px;
  padding-bottom: 6px;
  color: #002677 !important;
}
.icon {
  margin-right: 6%;
}

@media (max-width: 930px) {
  #indicators-initial {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 50px;
  }

  #indicators-initial a {
    margin: 0px !important;
  }
}
</style>

<style >
html body .input-login .input-group, html body .input-login .form-control{
  border: 1px solid #bbbec0 !important;
  border-radius: 4px;
}

html body .input-login .input-group .form-control{
  border: none !important;
}
</style>